/**
 * URL safety check for legal document links (Regulamin/Polityka prywatności).
 * Extracted from `ReacceptanceModal` (spec 2026-07-06-per-brand-legal-content,
 * M6) so every render-site that shows a `termsUrl`/`privacyUrl` — the modal,
 * `Register.tsx`, `Footer.tsx`, `CookieBanner.tsx`, the HotelB2B in-app legal
 * route — shares ONE definition of "safe" instead of drifting copies.
 *
 * Only `http:`/`https:` are accepted (mirrors the backend's
 * `Brand.legalConfig` DTO validator `@Matches(/^https?:\/\//i)`, S6). A URL
 * that fails this check must never be silently dropped — every caller falls
 * back to a disabled "Link niedostępny" placeholder instead (fail-safe: a
 * user must never see a working-looking link that goes nowhere, or worse,
 * to the wrong brand).
 *
 * Not a general-purpose URL validator — `utils/url-validation.ts`'s
 * `isSafeUrl` (grants article/operator links) is a separate, pre-existing
 * allowlist for a different domain; this one is scoped to legal content URLs.
 */
export function isSafeHttpUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}
